import React, { useState, useEffect } from 'react';
import { Table, Checkbox, Icon, Button, Input } from 'antd';
import _ from 'underscore';
import { Container, SearchContainer } from './styles';
import { withTranslation } from 'react-i18next';
import { USER_PERMISSIONS_MODAL as trans } from './translationValues';

const namespaces = ['USER_PERMISSIONS_MODAL'];

const TeamPermission = props => {
  const { permissions, onSuccess, isDisabled, t } = props;
  const [selectedTeam, setSelectedTeam] = useState([]);
  const [unselectedTeam, setUnselectedTeam] = useState([]);
  const [selectedItem, setSelectedItem] = useState([]);
  const [unSelectedItem, setUnSelectedItem] = useState([]);
  const [selectedIds, setSelectedIds] = useState(props.selectedIds);
  const [isChanged, setIsChanged] = useState(false);

  useEffect(() => {
    let getSelectedTeams = permissions.map(data => {
      let showoptions;
      let ids = _.pluck(data.permission, 'id');
      for (const id of selectedIds) {
        if (ids.includes(id)) {
          showoptions = true;
        }
      }
      if (showoptions) {
        return data;
      }
    });
    let selectedTeams = getSelectedTeams.filter(data => {
      if (data) {
        return data;
      }
    });
    if (selectedItem.length === 0) {
      setSelectedTeam(selectedTeams);
    } else {
      selectedTeams.map((item, i) => {
        if (item.rgid === selectedItem.rgid) {
          selectedTeams.splice(i, 1);
          selectedTeams.unshift(item);
        }
      });
      setSelectedTeam(selectedTeams);
    }
    let allTeams = permissions.map(data => {
      let showoptions;
      let ids = _.pluck(data.permission, 'id');
      for (const id of selectedIds) {
        if (ids.includes(id)) {
          showoptions = true;
        }
      }
      if (!showoptions) {
        return data;
      }
    });
    let teamsList = allTeams.filter(data => {
      if (data) {
        return data;
      }
    });
    if (unSelectedItem.length === 0) {
      setUnselectedTeam(teamsList);
    } else {
      teamsList.map((item, i) => {
        if (item.rgid === unSelectedItem[0].rgid) {
          teamsList.splice(i, 1);
          teamsList.unshift(item);
        }
      });
      setUnselectedTeam(teamsList);
    }
    // eslint-disable-next-line
  }, [isChanged]);

  const getColumnSearchProps = (dataIndex, isSelectedTeam) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <SearchContainer style={{ padding: 8 }}>
        <Input
          className="searchInput"
          placeholder={t(trans.SEARCH_TEAM_PLACEHOLDER.key, trans.SEARCH_TEAM_PLACEHOLDER.value)}
          value={selectedKeys[0]}
          onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(confirm)}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <Button
          type="primary"
          onClick={() => handleSearch(confirm)}
          icon="search"
          size="small"
          style={{ width: 90, marginRight: 8 }}
        >
          {t(trans.SEARCH_BUTTON.key, trans.SEARCH_BUTTON.value)}
        </Button>
        <Button onClick={() => handleReset(clearFilters)} size="small" style={{ width: 90 }}>
        {t(trans.CLEAR_BUTTON.key, trans.CLEAR_BUTTON.value)}
        </Button>
      </SearchContainer>
    ),
    filterIcon: filtered => (
      <Icon
        type="search"
        className={isSelectedTeam && 'selectedTeam'}
        style={{ color: filtered ? '#1890ff' : undefined }}
      />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        .toString()
        .toLowerCase()
        .includes(value.toLowerCase()),
  });

  const handleSearch = confirm => {
    confirm();
  };

  const handleReset = clearFilters => {
    clearFilters();
  };

  const availableCol = [
    {
      title: t(trans.AVAILABLE_TEAMS_LABEL.key, trans.AVAILABLE_TEAMS_LABEL.value),
      dataIndex: 'groupName',
      render: (text, record) => {
        return (
          <div
            key={record.rgid}
            onClick={() => {
              removeTeam(record.rgid);
              setSelectedItem(record);
              setUnSelectedItem([]);
            }}
            style={{ cursor: 'pointer', pointerEvents: isDisabled && 'none' }}
          >
            <p
              className={
                selectedItem.rgid === record.rgid || unSelectedItem.rgid === record.rgid
                  ? 'hidden'
                  : 'visible'
              }
            >
              {record.groupName}
            </p>
          </div>
        );
      },
      ...getColumnSearchProps('groupName'),
    },
  ];

  const accessibleCol = [
    {
      title: t(trans.ACCESSIBLE_TEAMS_LABEL.key, trans.ACCESSIBLE_TEAMS_LABEL.value),
      dataIndex: 'groupName',
      ...getColumnSearchProps('groupName', true),
      render: (text, record) => {
        return (
          <div
            className={
              selectedItem.rgid === record.rgid || unSelectedItem.rgid === record.rgid
                ? 'visible'
                : 'hidden'
            }
            style={{ display: 'flex', justifyContent: 'space-between' }}
            key={record.rgid}
          >
            <div>{record.groupName}</div>
            <div>
              {record.permission.map(
                value =>
                  selectedIds.includes(value.id) && (
                    <>
                      <Checkbox
                        checked={value.type === 'Read, Write' || value.type === 'Read Only'}
                        value={value}
                        onChange={e => {
                          {
                            setUnSelectedItem([record]);
                            setSelectedItem([]);
                            onChange(e, record, 'read');
                          }
                        }}
                      >
                        {t(trans.READ_CHECKBOX_LABEL.key, trans.READ_CHECKBOX_LABEL.value)}
                      </Checkbox>
                      <Checkbox
                        checked={value.type === 'Read, Write'}
                        value={value}
                        onChange={e => {
                          onChange(e, record, 'write');
                        }}
                      >
                        {t(trans.WRITE_CHECKBOX_LABEL.key, trans.WRITE_CHECKBOX_LABEL.value)}
                      </Checkbox>
                    </>
                  ),
              )}
            </div>
          </div>
        );
      },
    },
  ];

  const removeTeam = team => {
    const items = unselectedTeam;
    var selected = items.filter(item => {
      return item.rgid === team;
    });
    let selectedPermission = selected[0].permission.filter(value => value.type === 'Read, Write');
    // selectedIds.push(JSON.parse(JSON.stringify(selectedPermission[0].id)));
    let idsList = [selectedPermission[0].id, ...selectedIds];
    setSelectedIds(JSON.parse(JSON.stringify(idsList)));
    setIsChanged(!isChanged);
    onSuccess(idsList);
  };

  const onChange = (e, team, access) => {
    let value = e.target.value;
    let updatedIds = selectedIds;
    updatedIds = selectedIds.filter(item => item !== value.id);
    if (access === 'write') {
      let addId = team.permission.filter(item => item.id !== value.id);
      // updatedIds.push(JSON.parse(JSON.stringify(addId[0].id)));
      updatedIds = [addId[0].id, ...updatedIds];
    }
    setSelectedIds(JSON.parse(JSON.stringify(updatedIds)));
    setIsChanged(!isChanged);
    onSuccess(updatedIds);
  };

  return (
    <Container>
      <Table
        columns={availableCol}
        dataSource={unselectedTeam}
        pagination={false}
        scroll={{ y: 220 }}
        rowKey={record => record.rgid}
      />
      <Table
        columns={accessibleCol}
        dataSource={selectedTeam}
        pagination={false}
        scroll={{ y: 220 }}
        rowKey={record => record.rgid}
      />
    </Container>
  );
};

export default withTranslation(namespaces)(TeamPermission);
